module.exports = __webpack_public_path__ + "img/category-favorite.e2c604a2.png";